export default __webpack_public_path__ + "static/media/canva_logo.f5a41068.png";